import { type ReactNode } from "react";
import { cn } from "@/lib/utils/common";

interface TableFooterProps {
  children: ReactNode;
  className?: string;
}

export function TableFooter({ children, className }: TableFooterProps) {
  return <div className={cn("p-2 px-4", className)}>{children}</div>;
}
